export interface PromptSections {
  system: string;
  user: string;
  output: string;
}

const SECTION_RE = /^\[(SYSTEM|USER|OUTPUT)\]\s*$/gm;

export function parseSections(content: string): PromptSections {
  if (!content) return { system: '', user: '', output: '' };

  // Check if content has any section markers
  if (!SECTION_RE.test(content)) {
    SECTION_RE.lastIndex = 0;
    return { system: content, user: '', output: '' };
  }
  SECTION_RE.lastIndex = 0;

  const sections: Partial<PromptSections> = {};
  const matches: { type: string; index: number }[] = [];
  let match: RegExpExecArray | null;

  while ((match = SECTION_RE.exec(content)) !== null) {
    matches.push({ type: match[1], index: match.index });
  }

  for (let i = 0; i < matches.length; i++) {
    const start = matches[i].index + matches[i].type.length + 2; // skip [TYPE]\n
    const end = i + 1 < matches.length ? matches[i + 1].index : content.length;
    const text = content.slice(start, end).trim();
    const key = matches[i].type.toLowerCase() as keyof PromptSections;
    sections[key] = text;
  }

  // Content before first marker goes into system
  if (matches.length > 0 && matches[0].index > 0) {
    const preamble = content.slice(0, matches[0].index).trim();
    if (preamble) sections.system = (sections.system ? preamble + '\n\n' + sections.system : preamble) as any;
  }

  return {
    system: sections.system || '',
    user: sections.user || '',
    output: sections.output || '',
  };
}

export function joinSections(sections: PromptSections): string {
  const parts: string[] = [];
  if (sections.system) parts.push(`[SYSTEM]\n${sections.system}`);
  if (sections.user) parts.push(`[USER]\n${sections.user}`);
  if (sections.output) parts.push(`[OUTPUT]\n${sections.output}`);
  return parts.join('\n\n');
}

const VAR_RE = /\{\{([A-Z_][A-Z0-9_]*)\}\}/g;

export function extractVariables(content: string): string[] {
  const vars = new Set<string>();
  let match: RegExpExecArray | null;
  VAR_RE.lastIndex = 0;
  while ((match = VAR_RE.exec(content)) !== null) {
    vars.add(match[1]);
  }
  return Array.from(vars);
}
